var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSgpFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.875 0h67.5v45h-67.5V0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.875 0h67.5v22.5h-67.5V0Z",
    fill: "#DF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.688 3.769a7.912 7.912 0 0 0 .074 15.487 8.063 8.063 0 0 1-9.993-5.531A8.063 8.063 0 0 1 9.3 3.787c1.5-.43 2.887-.44 4.397-.018h-.01Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.469 10.312.46 1.407-1.22-.863-1.2.881.441-1.425-1.2-.872 1.49-.018.47-1.407.468 1.407h1.481l-1.19.89Zm1.64 4.875.47 1.416-1.22-.863-1.209.872.45-1.415-1.2-.882 1.49-.009.46-1.416.469 1.407h1.5l-1.21.89Zm5.485-.037.46 1.425-1.22-.872-1.2.872.441-1.416-1.2-.872 1.49-.018.47-1.407.468 1.407h1.481l-1.19.88Zm1.631-4.838.46 1.416-1.22-.863-1.2.872.45-1.415-1.209-.882 1.5-.009.45-1.416.469 1.407h1.5l-1.2.89Zm-4.34-3.215.468 1.425-1.219-.872-1.209.881.45-1.425-1.2-.881 1.481-.01.469-1.415.469 1.406h1.5l-1.21.89Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v45H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSgpFlag);
export default __webpack_public_path__ + "static/media/sgp-flag.c98af9537bf13b205951557be0643876.svg";
export { ForwardRef as ReactComponent };